// MainLayout.js — the shell every protected page renders inside.
//
// TARGET PATH: src/shared/layout/MainLayout.js
//
// Replicated from ecoh-ui-module's shared/layout/MainLayout.js, minus its
// resizable-sidebar machinery: this app's Navbar is a fixed-width sidebar driven
// by the --sidebar-width variable, so there is nothing to drag, collapse or
// measure. What is kept is the part that matters — one layout route holding the
// chrome, with <Outlet /> for the page.
//
// Before this existed, App.js repeated <SessionTimeout /> and <Navbar /> inside
// all sixteen protected routes. Beyond the duplication, that made it possible to
// add a route and silently forget the idle-timeout monitor.
//
// The boundary lives here rather than only at the top of App so that a crashing
// page leaves the sidebar intact — the user can navigate away instead of being
// stranded on an error screen.

import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SessionTimeout from '../components/SessionTimeout';
import Navbar from '../components/Navbar';
import ErrorBoundary from '../components/ErrorBoundary';

function MainLayout() {
  const location = useLocation();

  return (
    <>
      <SessionTimeout />
      <Navbar />
      {/*
        Keyed on the path so the boundary is a fresh instance per route. A
        boundary that has caught an error keeps showing its fallback until its
        state is reset, so without the key a crash on one page would follow the
        user to every page they navigated to next.
      */}
      <ErrorBoundary key={location.pathname} componentName="Page">
        <Outlet />
      </ErrorBoundary>
    </>
  );
}

export default MainLayout;
